!((document, Drupal, drupalSettings, $, lottie) => {
  'use strict';

  Drupal.behaviors.homeslider2020 = {
    attach: function (context, settings) {

      var scrollDownCTA = $('#ScrollDownCTA', context);

      if (scrollDownCTA) {
        scrollDownCTA.on('click', function() {
          $('html, body').animate({
            scrollTop: $('.main-content').offset().top
          });
        });
      };

      function initGamesSlider() {
        let slickGames = $('.homeslider--games:not(.loro-behavior-processed)', context);
        if (slickGames.length) {
          slickGames.slick({
            infinite: true,
            autoplay: true,
            // initialSlide: rand,
            autoplaySpeed: 5000,
            speed: 480,
            pauseOnHover: false,
            slidesToShow: 1,
            adaptiveHeight: false,
            fade: true,
            dots: false,
            arrows: true,
            prevArrow: $('.slick-button__prev'),
            nextArrow: $('.slick-button__next'),
          }).addClass('loro-behavior-processed');


          setTimeout(function () {
            slickGames.slick('slickGoTo', 0);
            $('.cloaked', context).addClass('cloaked--uncloaked');
          }, 300);

        }
      }
       initGamesSlider();

      if (lottie) {
        const container = document.querySelector('#ScrollDownCTA:not(.loro-behavior-processed)');
        lottie.loadAnimation({
          container,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          path: '../themes/custom/loro/libraries/lottie/bouncing_arrows_lottie_data.json'
        });
        container.classList.add('loro-behavior-processed');
      }
    }
  };
})(document, Drupal, drupalSettings, jQuery, lottie);
